(async () => {
  if (!customElements.get('product-comparison-popup')) {
    const { Fancybox } = await import('@fancyapps/ui');

    class ProductComparisonPopup extends HTMLElement {
      constructor() {
        super();
        this.fancybox();
        this.init();
      }

      init() {
        // comparison tab triggers
        this.triggers = this.querySelectorAll('[data-comparison-trigger]');
        this.tabs = this.querySelectorAll('[data-comparison-tab]');
        this.tabsWrapper = this.querySelector('[data-comparison-tabs]');
        this.tabActive = this.querySelector('[data-comparison-tab-active]');
        const popup = this.querySelector('popup-element');
        popup?.addEventListener('popup-toggled', (detail) => {
          if (detail.detail.open) {
            setTimeout(() => {
              popup.querySelector('.popup__content').classList.add('relative');
            }, 50);
          } else {
            popup.querySelector('.popup__content').classList.remove('relative');
          }
        });

        this.triggers.forEach((trigger) =>
          trigger.addEventListener('click', () => {
            this.switchTabs(trigger);
          })
        );
      }
      /*
       * Create fancybox
       */
      fancybox() {
        // Check if Fancybox exists
        if (typeof Fancybox == 'undefined') {
          return false;
        }

        Fancybox.bind('[data-fancybox]', {
          animated: false,
          showClass: false,
          mainClass: 'image-zoom',
          click: false,
          Carousel: {
            Dots: true,
            Navigation: true,
            Panzoom: {
              touch: (panzoom, event) => {
                return event?.target.nodeName !== 'MODEL-VIEWER';
              },
              click: (panzoom, event) => {
                return event?.target.nodeName !== 'MODEL-VIEWER';
              },
            },
          },
          on: {
            '*': (fancybox) => {
              if (!fancybox.container) return;

              const productMedia = document.querySelector('product-media');
              if (productMedia) {
                productMedia.initXRButton(fancybox);
                productMedia.initFancyboxPaginationBullets(fancybox.container);
              }
            },
          },
        });
      }

      switchTabs(trigger) {
        this.triggers.forEach((item) => {
          item === trigger ? item.classList.add('active') : item.classList.remove('active');
        });

        // get the index of the clicked trigger
        const index = [...this.triggers].indexOf(trigger);
        // calculate the transform value

        this.tabs.forEach((tab, tabIndex) => {
          const newPercentage = 100 * (tabIndex - index);
          tab.style.setProperty('--translate-x', `${newPercentage}%`);
        });

        // remove the before element from the first trigger
        // the element is needed to show the active tab when the page loads
        this.triggers[0].classList.remove('before:content-empty');
        this.triggers[0].classList.add('before:content-none');

        // get the width of the clicked tab
        const width = trigger.offsetWidth;
        // get the left offset of the clicked tab relative to the parent
        const left = trigger.offsetLeft;

        this.tabActive.style.width = `${width - 24}px`;
        this.tabActive.style.transform = `translateX(${left + 12}px)`;
      }
    }

    window.ProductComparisonPopup = ProductComparisonPopup;

    customElements.define('product-comparison-popup', ProductComparisonPopup);
  }
})();
